
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class DataQualityWorkflowInstanceDialog extends SiteEntityDialog<WorkflowInstanceRow, any> {
        protected getFormKey() { return DataQualityWorkflowInstanceForm.formKey; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getNameProperty() { return WorkflowInstanceRow.nameProperty; }
        protected getService() { return WorkflowInstanceService.baseUrl; }
        protected getEntitySingular() { return "Data Quality Exception";}

        protected form = new DataQualityWorkflowInstanceForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 290;
            this.form.Documents.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected updateInterface() {
            super.updateInterface();

            this.cloneButton.hide();
            if (this.entity.WorkflowClass1 != "MX:DQ TEST RESULT") {
                this.toolbar.findButton('edit-button').hide();
            }
            else {
                if (!this.isViewMode) {
                    makeReadOnly(this.byId('Form'));
                    Serenity.EditorUtils.setReadOnly(this.form.C1, false);
                    Serenity.EditorUtils.setReadOnly(this.form.D1, false);
                    Serenity.EditorUtils.setReadOnly(this.form.StatusCode, false);
                    Serenity.EditorUtils.setReadOnly(this.form.Txt3, false);
                }
            }

            this.deleteButton.hide();
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons.push({
                title: "Acknowledge",
                cssClass: 'acknowledge-button',
                icon: 'fa-thumbs-o-up',
                onClick: () => {
                    Q.confirm('Acknowledge this data quality exception?', () => {
                        WorkflowInstanceService.Update({
                            EntityId: this.entityId,
                            Entity: {
                                StatusCode: 'ACKNOWLEDGED'
                            }
                        },
                            response => {
                                Serenity.SubDialogHelper.triggerDataChange(this);
                                this.dialogClose();
                            });
                    });
                }
            });

            buttons.push({
                title: "Complete",
                cssClass: 'complete-button',
                icon: 'fa-check-square-o',
                onClick: () => {
                    Q.confirm('Complete this data quality exception?', () => {
                        WorkflowInstanceService.Update({
                            EntityId: this.entityId,
                            Entity: {
                                StatusCode: 'COMPLETED'
                            }
                        },
                            response => {
                                Serenity.SubDialogHelper.triggerDataChange(this);
                                this.dialogClose();
                            });
                    });
                }
            });

            buttons.push({
                title: "Details",
                cssClass: 'details-button',
                icon: 'fa-search',
                onClick: () => {
                    if (!this.entity.Key1 || !this.entity.Key2)
                        return;

                    Data.TestResultService.List({
                        ColumnSelection: Serenity.ColumnSelection.KeyOnly,
                        EqualityFilter: <Data.TestResultRow>{
                            TestCode: this.entity.Key1,
                            BatchId: this.entity.Key2 as any
                        }
                    },
                        response => {
                            if (!response.Entities.length) {
                                Q.notifyError("Can't locate the test results related to this instance!");
                                return;
                            }

                            var dlg = new Data.TestResultDialog();
                            dlg.loadByIdAndOpenDialog(response.Entities[0].RowId);
                        }
                    );   
                }
            });
            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var workflow = WorkflowRow.getLookup().itemById[(this.entity || {}).WorkflowCode];

            this.propertyGrid.enumerateItems((item, editor) => {
                if (WorkflowInstanceNamedFields[item.name]) {
                    if (workflow && workflow[item.name + "Name"]) {
                        var name = workflow[item.name + "Name"];
                        if (name == "test_code")
                            name = "Test";
                        else if (name == "fail_count")
                            name = "Failures";
                        else
                            name = titleize(name);

                        editor.getGridField().show()
                            .find('label.caption').text(name);
                    }
                    else if (workflow) {
                        editor.getGridField().hide();
                    }
                }
            });

            this.form.Documents.workflowInstanceId = this.entityId;

            this.toolbar.findButton('acknowledge-button').toggle(this.entity.StatusCode != "COMPLETED" && this.entity.StatusCode != "ACKNOWLEDGED");
            this.toolbar.findButton('complete-button').toggle(this.entity.StatusCode != "COMPLETED");
        }
    }
}